import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { Fault } from '@docma-mm-core/fault/fault';
import { DeviceService } from '@mydocma/core/src/lib/device';
import { MmFaultDownloadProgressDialogComponent } from './mm-fault/mm-fault-download-progress-dialog/mm-fault-download-progress-dialog.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialogState } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class BlockingDialogService {

  public appBlockedDialogRef: MatLegacyDialogRef<any> = null;
  private header$ = new BehaviorSubject<string>('');
  private body$ = new BehaviorSubject<string>('');
  private progressText$ = new BehaviorSubject<string>('');
  private processedFiles$ = new BehaviorSubject<number>(0);
  private showCancel$ = new BehaviorSubject<boolean>(false);
  private recordsText$ = new BehaviorSubject<string>('');
  private totalFilesAmount$ = new BehaviorSubject<number>(0);

  constructor(private dialog: MatDialog, private deviceService: DeviceService) { }

  show(header: string, body: string, totalFiles: number, showCancel: boolean, progressText: string, recordsText: string): Observable<boolean>{
    this.header$.next(header);
    this.body$.next(body)
    this.showCancel$.next(showCancel)
    this.progressText$.next(progressText);
    this.processedFiles$.next(0);
    this.recordsText$.next(recordsText);
    this.totalFilesAmount$.next(totalFiles);
    this.appBlockedDialogRef = this.dialog.open(MmFaultDownloadProgressDialogComponent, {
      panelClass: ['mydocma-dialog', 'mm-fault-download-progress-dialog'],
      disableClose: true,
      autoFocus: false,
      width: this.deviceService.isMobil() ? 'calc(100vw - 48px)' : '750px',
      height: this.deviceService.isMobil() ? 'auto' : null,
      data: { header$: this.header$, body$: this.body$, totalFilesAmount$: this.totalFilesAmount$, processedFilesAmount$: this.processedFiles$, showCancel$: this.showCancel$, progressText$: this.progressText$, recordsText$: this.recordsText$},
      backdropClass: ['cdk-overlay-dark-backdrop', 'allow-project-switch-backdrop']
    });

    return this.appBlockedDialogRef.afterClosed();
  }

  close(result?: any): void{
    this.appBlockedDialogRef?.close(result);
  }

  setHeader(header: string){
    this.header$.next(header);
  }
  
  setBody(body: string){
    this.body$.next(body)
  }

  setProgressText(text: string){
    this.progressText$.next(text);
  }

  setProcessedFiles(processedFiles: number){
    this.processedFiles$.next(processedFiles);
  }

  setShowCancel(showCancel: boolean){
    this.showCancel$.next(showCancel);
  }

  setRecordText(recordText: string){
    this.recordsText$.next(recordText);
  }

  setTotalFilesAmount(totalFiles: number){
    this.totalFilesAmount$.next(totalFiles);
  }

  isDialogOpen(): boolean {
    return !!this.appBlockedDialogRef && this.appBlockedDialogRef.getState?.() !== MatDialogState.CLOSED;
  }
  
}
